import React, { useEffect, useState, useRef, useCallback } from "react";
import { Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import Banner_Container from "../../Banners/container";
import InventoryList from "./InventoryList";
import ReplaceCartModal from "../../PopUp/ReplaceCartPopUp";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import TodaySpecialComponent from "./TodaySpecial/component";
import Procced from "../../ProccedToPay/component";
import BuyAgain from "./BuyAgain/Component";
import SearchBar from "./SearchBar/Component";
import VmInventoryHeader from "../../Header/component";
import PendingPickup from "../PendingPickup/component";
import WaitingLoder from "../../Loader/component";
import QRModal from "../VmList/Qr";
import SortFilterDrawer from "./Filter";
import NoActiveMachine from "./NoActiveMachine";

import "./vmlist.css";
import NoInternet from "../../NoInterNet/component";
import ServerErrorPage from "../../ServerError/ServerErrorPage";
import logger from "../../Utils/logger";

// ─── Pure helpers ────────────────────────────────────────────────────────────

const applyCartCounts = (inventory = [], cartItems = []) =>
  inventory.map((item) => {
    const match = cartItems.find(
      (c) => parseInt(c.slotId) === parseInt(item.slot_id)
    );
    return { ...item, mycount: match ? match.count : item.mycount ?? 0 };
  });

const getSortParams = (value) => {
  const map = {
    "price-low":    { sort_by: "price", sort_order: "asc" },
    "price-high":   { sort_by: "price", sort_order: "desc" },
    "stack-top":    { sort_by: "slot",  sort_order: "asc" },
    "stack-bottom": { sort_by: "slot",  sort_order: "desc" },
  };
  return map[value] ?? {};
};

const cartTotal = (items = []) =>
  items.reduce((sum, item) => sum + item.amount * item.count, 0);

// ─── Component ───────────────────────────────────────────────────────────────

const VmInventoryContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { makeApiRequest } = useApiRequest();

  const searchParams = new URLSearchParams(location.search);
  const machineId  = searchParams.get("machineId");
  const uuid       = searchParams.get("value");
  const showItems  = searchParams.get("showItems");
  const isDigital = searchParams.get("isDigital");
  // This must be using the URL param directly at useState init time


const [selectedCategoryIds, setSelectedCategoryIds] = useState(
  isDigital === "true" ? [25] : []
);
  // ── Machine / location state ──────────────────────────────────────────────
  const [vmName,          setVmName]          = useState(null);
  const [vmAddress,       setVmAddress]       = useState(null);
  const [uuidVmId,        setUuidVmId]        = useState(null);
  const [machineUuidFlag, setMachineUuidFlag] = useState(false);
  const [fUuid,           setFUuid]           = useState(null);

  // ── Inventory state ───────────────────────────────────────────────────────
  const [vmInventory,          setVmInventory]          = useState([]);
  const [vmInventoryWithCount, setVmInventoryWithCount] = useState([]);
  const [todaySpecialInventory,setTodaySpecialInventory]= useState([]);
  const [buyAgainList,         setBuyAgainList]         = useState([]);
  const [buyAgainWithCount,    setBuyAgainWithCount]    = useState([]);
  const [comboList,            setComboList]            = useState([]);
  const [comboListWithCount,   setComboListWithCount]   = useState([]); // eslint-disable-line no-unused-vars
  const [filterData,           setFilterData]           = useState(null);
  const [loadingVmData,        setLoadingVmData]        = useState(false);
  const [inventoryMsg]                                  = useState("Loading Data...");

  // ── Cart state ────────────────────────────────────────────────────────────
  const [preCart,      setPreCart]      = useState([]);
  const [preCartCombo, setPreCartCombo] = useState([]);
  const [totalAmount,  setTotalAmount]  = useState(0);
  const [replaceSlot,  setReplaceSlot]  = useState(null);
  const [replaceCard,  setReplaceCard]  = useState(false);

  // ── Orders ────────────────────────────────────────────────────────────────
  const [activeOrders, setActiveOrders] = useState([]);

  // ── UI / loading flags ────────────────────────────────────────────────────
  const [loader,          setLoader]          = useState(false);
  const [qrModalFlag,     setQrModalFlag]     = useState(false);
  const [filterFlag,      setFilterFlag]      = useState(false);
  const [showSearchField, setShowSearchField] = useState(false);
  const [searchTerms,     setSearchTerms]     = useState(null);
  const [noInternet,      setNoInternet]      = useState(false);
  const [serverError,      setServerError]      = useState(false);
  // ── Filter state ──────────────────────────────────────────────────────────
  const [tab,                 setTab]                 = useState("filters");
  const [categories,          setCategories]          = useState([]);

  const [sortValue,           setSortValue]           = useState("");
  const [priceRange,          setPriceRange]          = useState([0, 250]);
  const [trayLevel,           setTrayLevel]           = useState("all");
  const [isSample,             setIsSample]            =useState(false)
  const comboFetchedRef = useRef(false);

  // GET /cart de-dupe: one request at a time; calls made while one is in
  // flight are collapsed into a single follow-up request.
  const cartInFlightRef = useRef(false);
  const cartRefetchRef  = useRef(false);
  // Latest cart snapshot, readable from stale closures (e.g. today's special).
  const latestCartRef   = useRef({ items: [], machineId: null });

  // ─── Network error helper ─────────────────────────────────────────────────

  const handleNetworkError = useCallback((error) => {
    if (error.code === "ERR_NETWORK" || !error.response) {
      setNoInternet(true);
      setLoader(false);
      return true;
    }
    return false;
  }, []);

    const handleServerError = useCallback((error) => {
      logger.log("Error response for debugging:", error?.response?.status);
    const statusCode = error?.response?.data?.status?.code;
  
    if (
      statusCode === "INTERNAL_SERVER_ERROR" ||
      error?.response?.status === 500|| error.response.status === 502
    ) {
      logger.log("Server Error:", statusCode);
  
      setServerError(true); // 👈 state create karo
      setLoader(false);
      return true;
    }
  
    return false;
  }, []);


  // ── Persist machineId to localStorage ────────────────────────────────────
  useEffect(() => {
    if (machineId) localStorage.setItem("machineId", machineId);
  }, [machineId]);

  // ── Online / offline listeners ────────────────────────────────────────────
  useEffect(() => {
    if (!navigator.onLine) {
      setNoInternet(true);
      setLoader(false);
    }

    const goOffline = () => setNoInternet(true);

    const goOnline = () => {
      setNoInternet(false);
      // Re-trigger data fetch when connection is restored
      if (machineId) {
        fetchItems();
      }
    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online",  goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online",  goOnline);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Route guard on mount ──────────────────────────────────────────────────
 
useEffect(() => {
  const isMachineIdValid =
    machineId &&
    machineId.toLowerCase() !== "null" &&
    machineId.toLowerCase() !== "false";

  const qrRoute = `/entryPointQr?route=${encodeURIComponent(
    `machineId=${machineId}&value=${uuid}`
  )}`;

  if (isMachineIdValid) {
    // showItems is falsy → always send to QR flow (with value if available)
    if (!showItems || showItems === "false") {
      navigate(qrRoute); // ← goes here when showItems is false/null/missing
    }
    // showItems=true → stay on this page and load items (no navigate)
  } else if (uuid && (!showItems || showItems === "false")) {
    resolveMachineByUUID(uuid);
  }
}, []); // eslint-disable-line react-hooks/exhaustive-deps
  // ── Fetch items when machineId is ready ───────────────────────────────────
  useEffect(() => {
    if (machineId) {
      fetchItems();
      fetchBuyAgain(); // FIX: also fetch buy-again when machineId comes from URL
    }
  }, [machineId]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Side-fetches once vmInventory loads ───────────────────────────────────
  useEffect(() => {
    if (vmInventory.length > 0) {
      fetchComboInventory();
      fetchTodaySpecial();
      fetchActiveOrders();
    }
  }, [vmInventory]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Re-fetch buy-again when uuidVmId resolves (UUID flow) ─────────────────
  useEffect(() => {
    if (uuidVmId) fetchBuyAgain();
  }, [uuidVmId]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Sync inventory lists with counts ─────────────────────────────────────
  useEffect(() => {
    setVmInventoryWithCount(withZeroCount(vmInventory));
    setBuyAgainWithCount(withZeroCount(buyAgainList));
    setComboListWithCount(withZeroCount(comboList));
  }, [vmInventory, buyAgainList, comboList]);

  // ─── Inventory count utilities ────────────────────────────────────────────

  const withZeroCount = (list) =>
    list.map((item) => ({ ...item, mycount: item.mycount ?? 0 }));

  /**
   * Apply updated cart counts to every inventory list at once.
   * Called after every successful cart mutation or preCart fetch.
   */
  const updateAllInventories = (cartItems, currentMachineId) => {
    if (String(currentMachineId) !== String(machineId)) return;

    const apply = (setter) =>
      setter((prev) => (prev ? applyCartCounts(prev, cartItems) : prev));

    apply(setVmInventoryWithCount);
    apply(setTodaySpecialInventory);
    apply(setBuyAgainWithCount);
    apply(setFilterData);
  };

  // ─── API: resolve machine UUID → machineId ────────────────────────────────

  const resolveMachineByUUID = (targetUuid) => {
    const token = localStorage.getItem("UserJWTAuth");
    setFUuid(targetUuid);

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/outlet/machinebyuuid/${targetUuid}`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      handleSuccess: (res) => {
        const id = res?.data?.data?.machineId;
        if (id) {
          setUuidVmId(id);
          navigate(`/entryPointQr?route=${encodeURIComponent(
            `machineId=${id}&value=${targetUuid}`
          )}`);
        } else {
          toast.error("Machine not found for this device", {
            position: "top-right",
            autoClose: 1500,
          });
        }
      },
      handleError: (error) => {
        const code = error?.response?.data?.status?.code;
        if (code === "UNAUTHORIZED") {
          //navigate(`/login?value=${targetUuid},`);
               navigate("/login", {
        state: { from: location.pathname + location.search },
      }); 
        } else {
          setMachineUuidFlag(true);
        }
      },
    });
  };

  // ─── API: fetch inventory items (with optional filters) ───────────────────

  const fetchItems = ({ applyFilter = false } = {}) => {
    if (!machineId) return;
    setLoader(true);

    const token    = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");
    const params   = new URLSearchParams({ exclude_inactive: "false" });
/* 
    if (applyFilter) {
      params.set("price_min", priceRange[0]);
      params.set("price_max", priceRange[1]);
      const { sort_by, sort_order } = getSortParams(sortValue);
      if (sort_by)    params.set("sort_by",       sort_by);
      if (sort_order) params.set("sort_order",     sort_order);
      if (trayLevel && trayLevel !== "all") params.set("tray_level", trayLevel);
      if (selectedCategoryIds.length > 0)
        params.set("category_id_arr", selectedCategoryIds.join("|"));
    }
 */
  if (applyFilter) {
    params.set("price_min", priceRange[0]);
    params.set("price_max", priceRange[1]);
    const { sort_by, sort_order } = getSortParams(sortValue);
    if (sort_by)    params.set("sort_by",       sort_by);
    if (sort_order) params.set("sort_order",     sort_order);
    if (trayLevel && trayLevel !== "all") params.set("tray_level", trayLevel);
    if (selectedCategoryIds.length > 0)
      params.set("category_id_arr", selectedCategoryIds.join("|"));
  } else if (isDigital === "true") {
    // Auto-apply digital category filter on normal (non-filter) fetch
    params.set("price_min", 0);
    params.set("price_max", 250);
    params.set("category_id_arr", "25");
  }
    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/outlet/${machineId}/items?${params}`,
      method: "GET",
      headers: {
        Authorization:    `Bearer ${token}`,
      },
      handleSuccess: (res) => {
        setVmName(res?.headers?.name);
        setVmAddress(res?.headers?.address);
        setIsSample(res?.headers?.sample)

        const items = (res?.data?.data ?? []).map((item) => ({
          ...item,
          mycount: 0,
        }));

        if (applyFilter) {
          setFilterData(items);
        } else {
          setVmInventory(items);
        }

        setLoadingVmData(true);
        fetchPreCart();
        setLoader(false);
      },
      handleError: (error) => {
        logger.log("error---------",error?.response?.data.status.code=="INTERNAL_SERVER_ERROR")
        if(handleServerError(error)) return
        if (handleNetworkError(error)) return;
        if (error?.response?.data?.status?.code === "UNAUTHORIZED") {
          //navigate("/login");
              navigate("/login", {
state: { from: location.pathname + location.search },
      });
        }

        setLoader(false);
      },
    });
  };

  // ─── API: fetch combo inventory (once per mount) ──────────────────────────

  const fetchComboInventory = () => {
    if (comboFetchedRef.current) return;
    comboFetchedRef.current = true;

    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/outlet/${machineId}/combo`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      handleSuccess: (res) => setComboList(res.data.data ?? []),
      handleError: (error) => {
        if (handleNetworkError(error)) return;
      },
    });
  };

  // ─── API: fetch today's special ───────────────────────────────────────────

  const fetchTodaySpecial = () => {
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/outlet/${machineId}/special`,
      method: "GET",
      headers: {
        Authorization:    `Bearer ${token}`,
      },
      handleSuccess: (res) => {
        const items = (res?.data?.data ?? []).map((item) => ({
          ...item,
          mycount: 0,
        }));
        // Apply counts from the latest cart instead of re-fetching /cart.
        // If the cart request is still pending, updateAllInventories will
        // apply the counts to this list when it completes.
        const { items: cartItems, machineId: cartMachineId } = latestCartRef.current;
        setTodaySpecialInventory(
          cartItems.length > 0 && String(cartMachineId) === String(machineId)
            ? applyCartCounts(items, cartItems)
            : items
        );
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        toast.error(error?.response?.data?.status?.message ?? "Error", {
          position: "top-right",
          autoClose: 1500,
        });
      },
    });
  };

  // ─── API: fetch pre-cart ──────────────────────────────────────────────────

  const fetchPreCart = () => {
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    if (cartInFlightRef.current) {
      cartRefetchRef.current = true;
      return;
    }
    cartInFlightRef.current = true;

    const done = () => {
      cartInFlightRef.current = false;
      if (cartRefetchRef.current) {
        cartRefetchRef.current = false;
        fetchPreCart();
      }
    };

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/cart`,
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
      handleSuccess: (res) => {
        const cartItems    = res?.data?.data?.items ?? [];
        const preMachineId = res?.headers?.["machineid"];
        latestCartRef.current = { items: cartItems, machineId: preMachineId };
        done();

        setTotalAmount(cartTotal(cartItems));
        setPreCart(cartItems);
        setPreCartCombo(res?.data?.data?.comboDetails ?? []);
        updateAllInventories(cartItems, preMachineId);
      },
      handleError: (error) => {
        cartRefetchRef.current = false; // don't loop on a failing request
        done();
        if (handleNetworkError(error)) return;
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
          localStorage.removeItem("UserJWTAuth");
        }
      },
    });
  };

  // ─── API: fetch active orders ─────────────────────────────────────────────

  const fetchActiveOrders = () => {
    const token    = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/order/active`,
      method: "GET",
      headers: {
        Authorization:    `Bearer ${token}`,
        accept:           "application/json, text/plain, */*",
      },
      handleSuccess: (res) => setActiveOrders(res?.data?.data ?? []),
      handleError: (error) => {
        handleNetworkError(error);
      },
    });
  };

  // ─── API: fetch buy-again list ────────────────────────────────────────────

  const fetchBuyAgain = () => {
    const token    = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/outlet/${machineId}/previously-purchased`,
      method: "GET",
      headers: {
        Authorization:    `Bearer ${token}`,
      },
      handleSuccess: (res) => setBuyAgainList(res?.data?.data ?? []),
      handleError: (error) => {
        if (handleNetworkError(error)) return;
      },
    });
  };

  // ─── API: fetch categories ────────────────────────────────────────────────

  const fetchCategories = () => {
    setLoader(true);
    const token    = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/item/category`,
      method: "GET",
      headers: {
        Authorization:    `Bearer ${token}`,
      },
      handleSuccess: (res) => {
        setCategories(res?.data?.data ?? []);
        setLoader(false);
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        setLoader(false);
      },
    });
  };

  // ─── Cart operations ──────────────────────────────────────────────────────

  const handleCartOperation = (e, _index, slotId, currentCount, operation) => {
    e.stopPropagation();
    setLoader(true);

    const token        = localStorage.getItem("UserJWTAuth");
    const payloadCount = operation === "add" ? currentCount + 1 : currentCount - 1;

    // FIX: capture replaceCard value before resetting it
    const shouldReplace = replaceCard;

    if (preCart.length > 0 || preCartCombo.length > 0) {
      setReplaceSlot({ slotId, index: _index });
    }

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/cart?machineId=${machineId}&replace-cart=${shouldReplace}`,
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      data: [{ slotId: parseInt(slotId), count: payloadCount }],
      handleSuccess: (res) => {
        setLoader(false);
        setReplaceCard(false); // reset only after successful replace
        localStorage.setItem("card_id", res.headers["cart-id"]);

        const cartItems = res?.data?.data?.items ?? [];
        const matched   = cartItems.find(
          (item) => parseInt(item.slotId) === parseInt(slotId)
        );

        const applyOp = (item) => {
          if (item.slot_id !== slotId) return item;
          const next = matched
            ? matched.count
            : operation === "add"
            ? item.mycount + 1
            : Math.max(0, item.mycount - 1);
          return { ...item, mycount: next };
        };

        setVmInventoryWithCount((prev) => prev.map(applyOp));
        setTodaySpecialInventory((prev) => prev.map(applyOp));
        setBuyAgainWithCount((prev)     => prev.map(applyOp));
        setFilterData((prev)            => (prev ? prev.map(applyOp) : prev));

        fetchPreCart();
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        setLoader(false);
        if (
          error?.response?.data?.status?.message ===
          "Cart contains items from another machine"
        ) {
          setReplaceCard(true);
        }
        toast.error(error?.response?.data?.status?.message, {
          position: "top-right",
          autoClose: 1500,
        });
      },
    });
  };

  // FIX: set replaceCard=true first, then re-run the operation using updated state
  const replaceMyCardFun = (e) => {
    setReplaceCard(true);
    if (replaceSlot) {
      // Use a slight defer so setReplaceCard state settles, or pass flag directly
      setTimeout(() => {
        handleCartOperationWithReplace(e, replaceSlot.index, replaceSlot.slotId, 0, "add", true);
      }, 0);
    }
  };

  /**
   * Internal variant that accepts an explicit `forceReplace` flag,
   * used by replaceMyCardFun to avoid stale-closure issues with replaceCard.
   */
  const handleCartOperationWithReplace = (
    e,
    _index,
    slotId,
    currentCount,
    operation,
    forceReplace = false
  ) => {
    e.stopPropagation();
    setLoader(true);

    const token        = localStorage.getItem("UserJWTAuth");
    const payloadCount = operation === "add" ? currentCount + 1 : currentCount - 1;

    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/cart?machineId=${machineId}&replace-cart=${forceReplace}`,
      method: "PATCH",
      headers: { Authorization: `Bearer ${token}` },
      data: [{ slotId: parseInt(slotId), count: payloadCount }],
      handleSuccess: (res) => {
        setLoader(false);
        setReplaceCard(false);
        setReplaceSlot(null);
        localStorage.setItem("card_id", res.headers["cart-id"]);

        const cartItems = res?.data?.data?.items ?? [];
        const matched   = cartItems.find(
          (item) => parseInt(item.slotId) === parseInt(slotId)
        );

        const applyOp = (item) => {
          if (item.slot_id !== slotId) return item;
          const next = matched
            ? matched.count
            : operation === "add"
            ? item.mycount + 1
            : Math.max(0, item.mycount - 1);
          return { ...item, mycount: next };
        };

        setVmInventoryWithCount((prev) => prev.map(applyOp));
        setTodaySpecialInventory((prev) => prev.map(applyOp));
        setBuyAgainWithCount((prev)     => prev.map(applyOp));
        setFilterData((prev)            => (prev ? prev.map(applyOp) : prev));

        fetchPreCart();
      },
      handleError: (error) => {
        if (handleNetworkError(error)) return;
        setLoader(false);
        toast.error(error?.response?.data?.status?.message, {
          position: "top-right",
          autoClose: 1500,
        });
      },
    });
  };

  // ─── Filter handlers ──────────────────────────────────────────────────────

  const handleCategoryToggle = (id) => {
    setSelectedCategoryIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleReset = () => {
    setFilterData(null);
    setSelectedCategoryIds([]);
    setSortValue("");
    setPriceRange([0, 250]);
    setTrayLevel("all");
    fetchItems();
    closeFilter();
  };

  const applyFilter = () => {
    setLoader(true);
    fetchItems({ applyFilter: true });
    closeFilter();
  };

  // ─── UI helpers ───────────────────────────────────────────────────────────

  const closeFilter = () => setFilterFlag(false);
  const goToHome    = () => navigate("/");

  const filteredProducts = vmInventoryWithCount.filter((p) =>
    p.mv_name.toLowerCase().includes(searchTerms?.toLowerCase() ?? "")
  );

  // Calculate bottom padding based on active overlays
  const bottomPadding = (() => {
    const hasOrders = activeOrders?.length > 0;
    const hasCart   = preCart?.length > 0;
    if (hasCart && hasOrders)              return "135px";
    if (hasCart)                           return "50px";
    if (hasOrders && activeOrders.length > 1) return "115px";
    if (hasOrders)                         return "80px";
    return "0px";
  })();

  // ─── Early returns ────────────────────────────────────────────────────────

  if (qrModalFlag) {
    return (
      <QRModal
        ShowQRFun={() => setQrModalFlag(true)}
        qrModelflag={qrModalFlag}
        CloseQrFun={() => setQrModalFlag(false)}
        preCart={preCart}
        fetchMachineByUUID={resolveMachineByUUID}
      />
    );
  }

  if (noInternet) return <NoInternet />;
  if(serverError) return <ServerErrorPage/>

  if (machineUuidFlag) {
    return <NoActiveMachine uuid={fUuid} gotohome={goToHome} />;
  }

  // ─── Render ───────────────────────────────────────────────────────────────

  const displayItems = filterData
    ? filterData
    : searchTerms
    ? filteredProducts
    : vmInventoryWithCount;

  return (
    <>
      <SortFilterDrawer
        open={filterFlag}
        onClose={closeFilter}
        ApplyFillter={applyFilter}
        categories={categories}
        selectedCategoryIds={selectedCategoryIds}
        sortValue={sortValue}
        priceRange={priceRange}
        setPriceRange={setPriceRange}
        trayLevel={trayLevel}
        setTrayLevel={setTrayLevel}
        setSortValue={setSortValue}
        tab={tab}
        setTab={setTab}
        handleReset={handleReset}
        handleCategoryToggle={handleCategoryToggle}
      />

      {loader && <WaitingLoder />}

      <VmInventoryHeader
        title={vmName}
        subtitle={vmAddress}
        route="/"
        ShowQRFun={() => setQrModalFlag(true)}
        preCart={preCart}
      />

      <Box
        sx={{
          display: { xs: "block", sm: "block", md: "" },
          background:
            "radial-gradient(circle, rgba(245, 233, 233, 0.408) 0%, rgba(185, 245, 247, 0.34) 100%)",
          minHeight: "100vh",
          padding: "12px",
          color: "#fff",
        }}
      >
        {replaceCard && (
          <ReplaceCartModal
            replaceMyCardFun={replaceMyCardFun}
            setReplaceCard={setReplaceCard}
          />
        )}

        <div style={{ paddingTop: "50px" }}>
          <Banner_Container vmid={machineId ?? 0} />
        </div>

        {!searchTerms && (
          <BuyAgain
            buyAgainList={buyAgainWithCount}
            onIncrement={handleCartOperation}
            onDecrement={handleCartOperation}
          />
        )}

        {!searchTerms && (
          <TodaySpecialComponent
            onIncrement={handleCartOperation}
            onDecrement={handleCartOperation}
            data={todaySpecialInventory}
          />
        )}

        <div style={{ paddingBottom: bottomPadding }}>
          {showSearchField && (
            <SearchBar
              setSearchTerms={setSearchTerms}
              searchTerms={searchTerms}
              setShowSearchfiled={setShowSearchField}
            />
          )}

          <InventoryList
            items={displayItems}
            onIncrement={handleCartOperation}
            onDecrement={handleCartOperation}
            setFilterFlag={setFilterFlag}
            setSearchTerms={setSearchTerms}
            searchTerms={searchTerms}
            showSearchfiled={showSearchField}
            setShowSearchfiled={setShowSearchField}
            fetchCategories={fetchCategories}
            inventroyMsg={inventoryMsg}
            loadingVmdata={loadingVmData}
            isSample={isSample}
          />
        </div>
      </Box>

      {activeOrders?.[0] && (
        <PendingPickup
          preCart={preCart?.[0] ? preCart : undefined}
          activeOrders={activeOrders}
          page="vmItems"
        />
      )}

      {preCart?.[0] && (
        <Procced
          preCart={preCart}
          totalAmount={totalAmount}
          page="vmItems"
          isSample={isSample}
          items={displayItems}
          bottom={"10px"}
        />
      )}
    </>
  );
};

export default VmInventoryContainer;